import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportColumnHeader,
  EReportingTimeWindow,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAPositionsReportTableFilters,
  TPPAdvertiserId,
} from '../models/types'
import { IDAReportingPositionsTableResponse } from '../models'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingDAPositionsTableV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TDAPositionsReportTableFilters &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IDAReportingPositionsTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingDAPositionsTable_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    () => {
      return coreAPIV3.advertiserReporting().getAdvertiserPositionsReportTable(
        advertiserId,
        generateCorrelationId(),
        retailerId,
        campaignId,
        adGroupId,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status
      )
    },
    { suspense, enabled }
  )
}
